/**
 * @fileoverview GET fetcher for the "/apps/multi_language_settings/validate_translation_usage" endpoint.
 *
 * This is semantically a query (read-only, no side effects) that uses POST under the hood
 * because the message payload is too large for URL params. It's consumed via useDashboardApiQuery.
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsMultiLanguageSettingsValidateTranslationUsage } from "./constants";
import type {
  AppsMultiLanguageSettingsValidateTranslationUsageResult,
  AppsMultiLanguageSettingsValidateTranslationUsageProps,
} from "./types";
import { isAppsMultiLanguageSettingsValidateTranslationUsageResult } from "./validators";

export const getAppsMultiLanguageSettingsValidateTranslationUsage = reactQueryFetcherAdapter(
  appsMultiLanguageSettingsValidateTranslationUsage,
  (
    signal: AbortSignal,
    { message }: AppsMultiLanguageSettingsValidateTranslationUsageProps
  ): Promise<AppsMultiLanguageSettingsValidateTranslationUsageResult> => {
    return fetch(
      "/apps/multi_language_settings/validate_translation_usage",
      // This is a POST endpoint because the body can be huge, but it should be treated like a GET endpoint
      "POST",
      { message },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isAppsMultiLanguageSettingsValidateTranslationUsageResult
);
